import { FormControl, FormHelperText } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { FullWidthTextFieldWrapper } from "@ryde/controls";
import { ICustomField } from "@ryde/shared";

import { PolygonBlock } from "../../map";

export const GeoJsonPolygonTemplate: FC<ICustomField> = ({ name }) => {
  const { control } = useFormContext();

  return (
    <FullWidthTextFieldWrapper>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => {
          return (
            <FormControl
              error={!!error}
              data-e2e-template="geo-json-polygon-template"
            >
              <PolygonBlock
                value={value}
                enabledImportAreas
                onChange={onChange}
              />
              {error && <FormHelperText>{error.message}</FormHelperText>}
            </FormControl>
          );
        }}
      />
    </FullWidthTextFieldWrapper>
  );
};
